// extracted by mini-css-extract-plugin
export var container = "_so-0";
export var dotAnimation = "_so-2";
export var dotsLoading = "_so-1";